import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

const styles = (loading) =>
  makeStyles((theme) => ({
    iconAnimation: {
      animation: loading ? '$spin 1s linear infinite' : 'none',
    },
    '@keyframes spin': {
      '0%': {
        transform: 'rotate(0deg)',
      },
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
    buttonContainer: {
      display: 'flex',
      marginTop: 16,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      gridGap: theme.spacing(3),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
        gridGap: theme.spacing(1.5),
      },
    },
    buttonBox: {
      flex: 1,
      [theme.breakpoints.down('sm')]: {
        flex: 'none',
        width: '100%',
      },
    },
    tooltipSpan: {
      display: 'block',
    },
  }))

styles.propTypes = {
  loading: PropTypes.bool.isRequired,
}

export default styles
